/** Accessible Fortune Overview and Birth Profile tabs. */
(function () {
  'use strict';

  function activateTab(root, nextTab, moveFocus) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fortune-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-fortune-panel]'));
    var nextName = nextTab.getAttribute('data-fortune-tab');

    tabs.forEach(function (tab) {
      var active = tab === nextTab;
      tab.classList.toggle('fortune-experience__tab--active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    panels.forEach(function (panel) {
      var active = panel.getAttribute('data-fortune-panel') === nextName;
      panel.hidden = !active;
      panel.classList.toggle('fortune-experience__panel--active', active);
    });

    if (moveFocus) nextTab.focus();
    if (window.innerWidth < 768) nextTab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  function initTabs(root) {
    if (root.dataset.fortuneTabsReady === 'true') return;
    root.dataset.fortuneTabsReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fortune-tab]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activateTab(root, tab, false); });
      tab.addEventListener('keydown', function (event) {
        var index = tabs.indexOf(tab);
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        activateTab(root, tabs[nextIndex], true);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-fortune-experience]').forEach(initTabs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
